//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formCreate from '@form-create/element-ui';
import request from '@/api/request';
import ueditorFrom from '@/components/form-common/oa-wangeditor';
formCreate.component('ueditorFrom', ueditorFrom);
export default {
  name: 'DialogForm',
  components: {
    formCreate: formCreate.$form()
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    rolesConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isRequest: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      dialogFormVisible: false,
      option: {
        form: {
          labelWidth: '75px',
          labelSuffix: '：'
        },
        submitBtn: false,
        global: {
          frame: {
            props: {
              closeBtn: false,
              okBtn: false,
              onLoad: function onLoad(e) {
                e.fApi = _this.$refs.fc.$f;
              }
            }
          }
        }
      },
      // 表单配置
      rules: [],
      type: ''
    };
  },
  watch: {
    rolesConfig: {
      handler: function handler(nVal, oVal) {
        this.rules = this.rolesConfig;
        this.type = this.rules[0].value;
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.dialogFormVisible = false;
    },
    open: function open() {
      this.dialogFormVisible = true;
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$refs.fc.$f.submit(function (formDatas, fApi) {
        if (_this2.formData.hasOwnProperty('options')) {
          formDatas = Object.assign(formDatas, _this2.formData.options);
        }
        if (_this2.isRequest) {
          request[_this2.formData.method.toLowerCase()](_this2.formData.action, formDatas).then(function (res) {
            if (_this2.rules[0].value === 2) {
              _this2.$emit('isOk', res.data);
            } else {
              _this2.$emit('isOk');
              _this2.handleClose();
            }
          });
        } else {
          _this2.$emit('changData', formDatas);
        }
      });
    }
  }
};